import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Permission } from '../../models/permission.model';
import { Role } from '../../models/role.model';
import { AccountService } from "../../services/account.service";
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { AuthService } from "../../services/auth.service";
import { ConfigurationService } from '../../services/configuration.service';
import { RoleServices } from "../../services/roles.service";

@Component({
    selector: 'roles',
    template: require('./roles.component.html'),
    styles: [require('./roles.component.css')],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.None
})

export class RolesComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];
    addMode: boolean = false;
    editMode: boolean = false;
    role = new Role();
    roles: Role[] = [];
    rowsCache: Role[] = [];
    allPermissions: Permission[] = [];
    selectedValues: { [key: string]: boolean; } = {};

    rows: Role[] = [];
    // disproles: any;
    selectedRoles: Role[] = []; // Note: this property needs to be here, Used in HTML Side.

    loginStatusSubscription: any;
    loadingIndicator: boolean;
    @Input()
    isModal = false;

    constructor(private alertService: AlertService, private authService: AuthService, private accountService: AccountService, private roleservices: RoleServices, private configurations: ConfigurationService) { }

    ngOnInit() {
        if (this.canviewRolesPermission && this.canmanageRolesPermission) {
            this.loadData();
        }
        this.loginStatusSubscription = this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
            if (this.getShouldRedirect()) {
                this.authService.redirectLoginUser();
            }
        });
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    getShouldRedirect() {
        return !this.isModal && this.authService.isLoggedIn && !this.authService.isSessionExpired;
    }

    add() {
        this.addMode = true;
        this.selectedValues = {};
        this.role = new Role;
    }

    saveRoles(form: NgForm) {
        if (this.getSelectedPermissions().length > 0) {
            if (form.valid) {
                if (this.role.Id != null) {
                    this.role.Permissions = this.getSelectedPermissions();
                    this.role.Name = form.value.Name;
                    this.role.Description = form.value.Description;
                    this.role.Id = form.value.Id;
                    const upRoleSubscriber = this.accountService.updateRole(this.role).subscribe(response => {
                        this.alertService.showMessage("Rol", "Update succesvol", MessageSeverity.success);
                        // this.getAllRoles();
                        this.loadData();
                    });
                    this.subscribers.push(upRoleSubscriber);
                } else {
                    this.role = new Role();
                    this.role.Name = form.value.Name;
                    this.role.Description = form.value.Description;
                    this.role.Permissions = this.getSelectedPermissions();

                    const newRoleSubscriber = this.accountService.newRole(this.role).subscribe(response => {
                        this.alertService.showMessage('Rol', 'Succesvol opslaan', MessageSeverity.success);
                        this.loadData();
                        // this.getAllRoles();
                    });
                    this.subscribers.push(newRoleSubscriber);
                }
                this.resetForm(form);
            }
        } else {
            this.alertService.showMessage('Rol', 'Toestemming moet worden geselecteerd!', MessageSeverity.error);
        }
    }

    windowScrollTop() {
        window.scrollTo(0, 0);
    }

    loadData() {
        this.loadingIndicator = true;
        const permissionSubscriber = this.accountService.getRolesAndPermissions()
            .subscribe(results => {
                this.loadingIndicator = false;
                const roles = results[0];
                const permissions = results[1];

                roles.forEach((role, index, roles) => {
                    (<any>role).index = index + 1;
                });

                this.rowsCache = [...roles];
                this.rows = roles;
                this.roles = roles;

                this.allPermissions = permissions;
            }, error => {
                this.loadingIndicator = false;
                this.alertService.showStickyMessage("Laad fout", 'Kan geen rollen ophalen van de server.\r\nFouten: "${Utilities.getHttpResponseMessage(error)}"',
                    MessageSeverity.error, error);
            });
        this.subscribers.push(permissionSubscriber);
    }

    resetForm(form: NgForm) {
        form.resetForm();
        this.addMode = false;
        this.editMode = false;
        this.role = new Role();
    }

    editRole(role: Role) {
        this.editMode = true;
        role.Permissions = role.Permissions != null ? role.Permissions.filter(f => f && f != null) : null;
        role.Permissions.forEach(p => this.selectedValues[p.Value] = true);
        this.role = role;
    }

    deleteRole(role: Role) {
        this.alertService.showDialog('Ben je zeker om rol te verwijderen:' + " " + role.Description + '\?', DialogType.confirm, () => {
            const deleteSubscriber = this.accountService.deleteRole(role).subscribe(response => {
                this.alertService.showMessage('Rol', 'Met succes verwijderd!', MessageSeverity.success);
                // this.getAllRoles();
                this.loadData();
            });
            this.subscribers.push(deleteSubscriber);
        });
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    selectAll() {
        this.allPermissions.forEach(p => this.selectedValues[p.Value] = true);
    }

    selectNone() {
        this.allPermissions.forEach(p => this.selectedValues[p.Value] = false);
    }

    toggleGroup(groupName: string) {
        let firstMemberValue: boolean;

        this.allPermissions.forEach(p => {
            if (p.GroupName !== groupName) {
                return;
            }
            if (firstMemberValue == null) {
                firstMemberValue = this.selectedValues[p.Value] == true;
            }
            this.selectedValues[p.Value] = !firstMemberValue;
        });
    }

    private getSelectedPermissions() {
        const temppermission: any = this.allPermissions;
        return temppermission.filter(p => this.selectedValues[p.Value] == true);
    }

    get canmanageRolesPermission() {
        return this.accountService.userHasPermission(Permission.manageRolesPermission);
    }

    get canviewRolesPermission() {
        return this.accountService.userHasPermission(Permission.viewRolesPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/roles/roles.component.ts